export const FloatWhatsAppButton = () => {
  return (
    <a href="https://wa.me/5511914849799" target="_blank" rel="noopener noreferrer" className="fixed bottom-4 right-4 bg-green-500 text-white rounded-full p-1 shadow-lg hover:bg-green-600 transition-colors">
      <img width={40} height={40} src="/whatsapp-icon.png" alt="WhatsApp" />
    </a>
  )
}